import axios from '../utils/API'
import { saveInLocalStorage } from '../helper/storage'

const brandRegister = (user, setBrandSuccess) => {
  axios.post('add-brand', user).then(res => {
    console.log('res:', res)
    console.log('user:', user)
    if (res.data.status === 'Success') {
      setBrandSuccess(true)
    }
    // else if (res.data.status === 'Failed') {
    //   setAuthError(res.data.error)
    // }
  })
}
const brandLogin = (brand, data, setData) => {
  axios.post('brand/login', brand).then(res => {
    console.log('res:', res)
    console.log('user:', brand)
    if (res.data.status === 'Success') {
      console.log('success')
      setData(res.data.data)
      saveInLocalStorage('brandData:', data)
    }
  })
}

const createCampaign = (campaignData, modalShow) => {
  axios.post('create-campaign', campaignData).then(res => {
    console.log('res:', res.data)
    if (res.data.status === 'Success') {
      modalShow()
    }
    console.log('campaign:', campaignData)
  })
}

const createProfile = data => {
  return axios.post('update-brand-profile', data)
}
const checkRegExp = (key, value, regex, errorSetter) => {
  return regex.test(value)
    ? errorSetter({
        [key]: false,
      })
    : errorSetter({
        [key]: true,
      })
}
const handleChange = (event, regex, inputSetter, errorSetter) => {
  const { id, value } = event.target
  inputSetter({ [id]: value })
  checkRegExp(id, value, regex, errorSetter)
}

const handleTextarea = (event, inputSetter, errorSetter) => {
  const { id, value } = event.target
  inputSetter({ [id]: value })
  return value.trim().length <= 0
    ? errorSetter({
        [id]: true,
      })
    : errorSetter({
        [id]: false,
      })
}

const onChange = (event, inputSetter) => {
  const { id, value } = event.target
  inputSetter({ [id]: value })
}

export {
  brandRegister,
  handleChange,
  brandLogin,
  createCampaign,
  onChange,
  createProfile,
  handleTextarea,
}
